import { CategoryRepository, UpdateCategoryInput } from '../../domain/repositories/category.repository';
import { CategoryEntity } from '../../domain/entities/category.entity';

export class UpdateCategoryUseCase {
  constructor(private readonly categoryRepository: CategoryRepository) {}

  async execute(id: string, input: UpdateCategoryInput): Promise<CategoryEntity> {
    return this.categoryRepository.updateCategory(id, input);
  }
}
